<template>
  <v-app  id="app" class="d-flex justify-center">
    <v-app-bar  app color="yellow" dark>
      <div  class="d-flex align-center">
        <h1 style="color:black" >Todo or Not To Do</h1>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
<v-content>
  <TodoList/>
</v-content>
  </v-app>
</template>

<script>
import TodoList from "./components/TodoList";

export default {
  name: "App",

  components: {
    TodoList,
  },

  data: () => ({
    //
  }),
};
</script>

<style>

#app {
  scroll-behavior: smooth;
overflow-x: hidden;
overflow-y: hidden;
overflow: hidden;

}


</style>
